import React from 'react'
import styles from './LinkRow.module.css'
import c from 'classnames'
import Link from '../../atoms/link/Link'
import Text, { ITextProps } from '../../atoms/text/Text'
import IconChevronRight from '../../icons/IconChevronRight'

interface IProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  className?: string
  children: React.ReactNode
  path?: string
  href?: string
  textProps?: Partial<Omit<ITextProps, 'children'>>
}

const LinkRow = ({ path, className, children, href, textProps = {}, ...rest }: IProps) => {
  if (href) {
    return (
      <a className={c(styles.container, className)} href={href} {...rest}>
        <Text {...textProps}>{children}</Text>

        <IconChevronRight size="xs" variant="max" />
      </a>
    )
  }

  return (
    <Link path={path as string} className={c(styles.container, className)} {...rest}>
      <Text element="span" {...textProps}>
        {children}
      </Text>

      <IconChevronRight size="xs" variant="max" />
    </Link>
  )
}

export default React.memo(LinkRow)
